import { useState, useEffect, useSyncExternalStore } from 'react';
import { getPendingCount, getFailedCount, subscribe } from '@/lib/pwa/outbox';
import { subscribeSyncState, getSyncState } from '@/lib/pwa/syncManager';

interface SyncStatus {
  pendingCount: number;
  failedCount: number;
  isSyncing: boolean;
  lastSyncAt: number | null;
}

/**
 * Hook que rastreia o status do outbox de sincronização offline.
 *
 * Conectado ao outbox real (IndexedDB) e ao syncManager.
 * Reage automaticamente a mudanças via padrão pub/sub.
 *
 * Equivalente Angular: um service que faz subscribe num BehaviorSubject
 * do estado de sincronização.
 */
export function useSyncStatus(): SyncStatus {
  const [pendingCount, setPendingCount] = useState(0);
  const [failedCount, setFailedCount] = useState(0);

  // Usar useSyncExternalStore para sync state (evita setState síncrono no useEffect)
  const syncState = useSyncExternalStore(
    subscribeSyncState,
    getSyncState,
    getSyncState,
  );

  useEffect(() => {
    // Contagem inicial
    getPendingCount().then(setPendingCount);
    getFailedCount().then(setFailedCount);

    // Inscrever-se nas mudanças do outbox
    const unsubOutbox = subscribe(() => {
      getPendingCount().then(setPendingCount);
      getFailedCount().then(setFailedCount);
    });

    return unsubOutbox;
  }, []);

  return {
    pendingCount,
    failedCount,
    isSyncing: syncState.isSyncing,
    lastSyncAt: syncState.lastSyncAt,
  };
}
